"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.sankey = exports.right = exports.left = exports.justify = exports.center = void 0;
/**
 * 桑基图布局代码，Fork from https://github.com/d3/d3-sankey/tree/master/src
 * 主要修改：
 * 1. 删除 d3-array 依赖
 * 2. 修改一些 set map 的遍历
 * 3. 数组创建出 [empty] 导致出错
 * 4. 通过 align 方法实现 depth 自定义
 */
var sankey_1 = require("./sankey");
Object.defineProperty(exports, "sankey", { enumerable: true, get: function () { return sankey_1.Sankey; } });
var align_1 = require("./align");
Object.defineProperty(exports, "center", { enumerable: true, get: function () { return align_1.center; } });
Object.defineProperty(exports, "justify", { enumerable: true, get: function () { return align_1.justify; } });
Object.defineProperty(exports, "left", { enumerable: true, get: function () { return align_1.left; } });
Object.defineProperty(exports, "right", { enumerable: true, get: function () { return align_1.right; } });
//# sourceMappingURL=index.js.map